import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() messageL2: string;
  @Input() cancelButtonTitle: string;
  @Input() confirmButtonTitle: string;
  @Output() action = new EventEmitter<boolean>();
  modalRef: NgbModalRef;

  constructor(
    public bsModalRef: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
  }

  public confirmModal() {
    this.modalRef = this.modalService.open(this.confirm, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
  }

  confirm(): void {
    this.action.emit(true);
    this.bsModalRef.close();
  }

  cancel(): void {
    this.action.emit(false);
    this.bsModalRef.close();
  }

  close(): void {
    this.bsModalRef.close();
  }
}
